import './polyfills';
import angular from 'angular';
import watch from './components/watch';
import header from './components/header';

angular.module('app', [watch, header]).config([
    '$compileProvider',
    function($compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|data|mailto):/);
    }
]);
angular.element(document).ready(() => {
    angular.bootstrap(document, ['app'], { strictDi: false });
});
